import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { categoriesAPI } from '../../config/api'
import NabSubBar from '../NabSubBar/NabSubBar'

const CategoryListContainer = () => {
    const [categories, setCategories] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const navigate = useNavigate()

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                setLoading(true)
                setError(null)
                
                const data = await categoriesAPI.getCategories()

                const rawCategories = Array.isArray(data)
                    ? data
                    : data?.data?.categories ?? data?.categories ?? []

                const categoriesData = Array.isArray(rawCategories)
                    ? rawCategories
                    : rawCategories && typeof rawCategories === 'object'
                        ? Object.values(rawCategories)
                        : []

                setCategories(categoriesData)
            } catch (error) {
                console.error('Error fetching categories:', error)
                setError('Error al cargar las categorías')
            } finally {
                setLoading(false)
            }
        }

        fetchCategories()
    }, [])

    const handleCategoryClick = (categoryName) => {
        navigate(`/Shop/category/${categoryName}`)
    }

    if (loading) return <div className="text-center p-5">Cargando categorías...</div>
    if (error) return <div className="alert alert-danger m-4">{error}</div>

    return (
        <div>
            <NabSubBar />
            <div className="container my-5">
                <h2 className="text-center mb-4">Categorías de Productos</h2>
                <div className="row g-4">
                    {Array.isArray(categories) && categories.map((category, index) => {
                        const categoryLabel = typeof category === 'string'
                            ? category
                            : category?.nombre || category?.name || String(category)

                        return (
                        <div key={`${categoryLabel}-${index}`} className="col-md-4 col-sm-6">
                            <div 
                                className="card h-100 shadow-sm category-card"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleCategoryClick(categoryLabel)}
                            >
                                <div className="card-body text-center d-flex flex-column justify-content-center">
                                    <h3 className="card-title text-capitalize">{categoryLabel}</h3>
                                    <p className="text-muted">Ver productos</p>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default CategoryListContainer
